import { bunja } from 'bunja';
import { atom } from 'jotai';

import { addDaysUTC, startOfUTCDay, timestampToDate } from '@flipster/utils/datetime';

import { competitionBunja } from '../../state';

export const dailyCheckInMinDays = 2;

export const dailyCheckInBunja = bunja(() => {
  const { dailyCheckInAtom } = bunja.use(competitionBunja);

  const dailyCheckInHistoryAtom = atom((get) => {
    const dailyCheckIn = get(dailyCheckInAtom);
    return dailyCheckIn?.checkInHistory ?? [];
  });

  const dailyCheckInListAtom = atom((get) => {
    const dailyCheckIn = get(dailyCheckInAtom);

    if (!dailyCheckIn) return [];
    const start = startOfUTCDay(timestampToDate(dailyCheckIn.startDate));
    const end = startOfUTCDay(timestampToDate(dailyCheckIn.endDate));

    let cursor = start;
    const dates: Date[] = [];
    while (cursor.getTime() <= end.getTime()) {
      dates.push(cursor);
      cursor = addDaysUTC(cursor, 1);
    }

    return dates;
  });

  const dailyCheckInSuccessAtom = atom((get) => {
    const dailyCheckInHistory = get(dailyCheckInHistoryAtom);
    const dailyCheckInList = get(dailyCheckInListAtom);

    const successList = dailyCheckInList.map((dateUTC) => {
      const dateUTCMs = dateUTC.getTime();
      return dailyCheckInHistory.some((h) => {
        const checkedInDateUTCStart = startOfUTCDay(timestampToDate(h.checkedInAt));
        return checkedInDateUTCStart.getTime() === dateUTCMs;
      });
    });

    const successCount = successList.filter((success) => success).length;
    const todayUTC = startOfUTCDay(new Date());
    const remainingAvailableCheckIns = dailyCheckInList.filter((dateUTC) => {
      const isTodayUTC = dateUTC.getTime() === todayUTC.getTime();
      if (dateUTC.getTime() > todayUTC.getTime()) return true;
      if (isTodayUTC) {
        const isCheckedInTodayUTC = dailyCheckInHistory.some((h) => {
          const checkedInDateUTCStart = startOfUTCDay(timestampToDate(h.checkedInAt));
          return checkedInDateUTCStart.getTime() === dateUTC.getTime();
        });
        return !isCheckedInTodayUTC;
      }
      return false;
    }).length;
    const daysToAchieveMinDays = dailyCheckInMinDays - successCount;
    const canAchieveMinWithinPeriod =
      successCount < dailyCheckInMinDays && remainingAvailableCheckIns >= daysToAchieveMinDays;

    const isCheckedInToday = dailyCheckInHistory.some((h) => {
      const checkedInDateUTCStart = startOfUTCDay(timestampToDate(h.checkedInAt));
      return checkedInDateUTCStart.getTime() === todayUTC.getTime();
    });

    return {
      isAllSuccess: successList.every((success) => success),
      successCount,
      remainingAvailableCheckIns,
      daysToAchieveMinDays,
      canAchieveMinWithinPeriod,
      isCheckedInToday,
    };
  });

  return {
    dailyCheckInAtom,
    dailyCheckInHistoryAtom,
    dailyCheckInListAtom,
    dailyCheckInSuccessAtom,
  };
});
dailyCheckInBunja.debugLabel = 'dailyCheckInBunja';
